// src/lib/filesToEtlUnits/transforms/span/initial-time-prop.js
/**
 * Time prop template
 *
 */
const initialTimeValue = {
  reference: {
    idx: undefined,
    value: '',
    isoFormat: '',
  },
  interval: {
    unit: '',
    count: 1,
  },
};

export default initialTimeValue;
